export enum AppEnv {
  dev = 'dev',
  staging = 'staging',
  prod = 'prod',
}
